import { Link } from "react-router-dom";
import AnimeCard from "@/components/feature/AnimeCard";
import { animeList } from "@/mocks/anime";

export default function PopularSection() {
  const popular = [...animeList].sort((a, b) => b.score - a.score).slice(0, 4);

  return (
    <section className="bg-background-50 py-10 md:py-14">
      <div className="mx-auto max-w-7xl px-4 md:px-6">
        <div className="mb-6 flex items-end justify-between gap-4">
          <div>
            <span className="text-xs font-medium text-primary-600">高分连载</span>
            <h2 className="mt-1 text-xl font-bold text-foreground-950 md:text-2xl">
              本周热门追番推荐
            </h2>
            <p className="mt-1 text-sm text-foreground-600">
              根据评分与观看热度整理，口碑与流量双双在线。
            </p>
          </div>
          <Link
            to="/series"
            className="whitespace-nowrap text-sm font-medium text-primary-600 hover:text-primary-700"
          >
            全部连载 <i className="ri-arrow-right-line"></i>
          </Link>
        </div>

        <div className="grid grid-cols-2 gap-4 sm:grid-cols-3 lg:grid-cols-4">
          {popular.map((anime, i) => (
            <div key={anime.id} className="relative">
              <span className="absolute -left-1 -top-2 z-10 flex h-7 w-7 items-center justify-center rounded-full bg-secondary-500 font-heading text-sm text-background-50">
                {i + 1}
              </span>
              <AnimeCard anime={anime} />
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}